<div class="container-fluid p-0">
  <app-header></app-header>
  <div style="top: 64px; height: auto; width: 100%; position: absolute">
    <router-outlet></router-outlet>
  </div>
</div>
